import { createContext, useContext, ReactNode } from "react";

interface SmoothScrollContextType {
  lenis: null;
}

const SmoothScrollContext = createContext<SmoothScrollContextType>({ lenis: null });

export function useSmoothScroll() {
  return useContext(SmoothScrollContext);
}

interface SmoothScrollProviderProps {
  children: ReactNode;
}

export default function SmoothScrollProvider({ children }: SmoothScrollProviderProps) {
  return (
    <SmoothScrollContext.Provider value={{ lenis: null }}>
      {children}
    </SmoothScrollContext.Provider>
  );
}
